"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCDownIcon24Solid = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCDownIcon24Solid = forwardRef_1.forwardRef('ArrowCDownIcon24Solid', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 24 }, props),
        react_1.default.createElement("path", { d: "M21.058 7.44a1.5 1.5 0 0 1 0 2.12l-6.406 6.407a3.75 3.75 0 0 1-5.304 0L2.942 9.561a1.5 1.5 0 1 1 2.121-2.122l6.407 6.407a.75.75 0 0 0 1.06 0l6.407-6.407a1.5 1.5 0 0 1 2.121 0Z" })));
});
